import { render } from "./CreateGroupRow.vue?vue&type=template&id=8521314a&scoped=true"
import script from "./CreateGroupRow.vue?vue&type=script&lang=js"
export * from "./CreateGroupRow.vue?vue&type=script&lang=js"

import "./CreateGroupRow.vue?vue&type=style&index=0&id=8521314a&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8521314a"]])

export default __exports__